'use client';

import Image from 'next/image';

import { useNativeLayout } from '~/(tenant)/_components/native/_lib/native-layout-context';

/**
 * Local monochrome glyphs render as a mask so they follow the text colour.
 * Native always does this; web opts in with `masked` (the sport tab strip,
 * where unselected tabs are muted).
 */
export function BookingChipIcon({
  src,
  alt,
  size = 16,
  masked,
}: {
  src: string;
  alt: string;
  size?: 16 | 24;
  masked?: boolean;
}) {
  const isNativeLayout = useNativeLayout();
  const isLocalMonochromeIcon = /^\/images\/book\/[a-z-]+\.svg$/.test(src);

  if ((masked ?? isNativeLayout) && isLocalMonochromeIcon) {
    return (
      <span
        aria-hidden="true"
        // inline-block: the size lives in `style`, which an inline span
        // ignores outside a flex parent (e.g. the booking-type tile).
        className="inline-block flex-shrink-0 bg-current align-middle"
        style={{
          width: size,
          height: size,
          maskImage: `url("${src}")`,
          maskSize: 'contain',
          maskPosition: 'center',
          maskRepeat: 'no-repeat',
          WebkitMaskImage: `url("${src}")`,
          WebkitMaskSize: 'contain',
          WebkitMaskPosition: 'center',
          WebkitMaskRepeat: 'no-repeat',
        }}
      />
    );
  }

  return (
    <Image
      src={src}
      alt={alt}
      width={size}
      height={size}
      className="flex-shrink-0"
      style={{ width: size, height: size }}
    />
  );
}
